import PropTypes from 'prop-types';
import React from 'react';

import FlagIcon from '../FlagIcon';

const LocaleFlagIcon = ({ locale, alt, decorative }) => {
  return <FlagIcon countryCode={locale} alt={alt} decorative={decorative} />;
};

LocaleFlagIcon.propTypes = {
  locale: PropTypes.string.isRequired,
  alt: PropTypes.string,
  decorative: PropTypes.bool,
};

LocaleFlagIcon.defaultProps = {
  alt: undefined,
  decorative: false,
};

export default LocaleFlagIcon;
